import React from 'react';
import Hyphenated from 'react-hyphen';
import {RegLink} from './PurchaseElements.js'

function About() {
  return (
    <div>
      <Hyphenated>
        <p>
          To schedule a delivery or pickup (currently serving the NYC area only), reach out via <RegLink href="mailto:matineemagicchocolate@gmail.com">email,</RegLink> message us on 
          <RegLink href="https://signal.me/#eu/hiJtzCmeR40Kt2arrQxsoq_dNgwl6QVLHu1vizeVqnRE9KzY7OZOOprwnpd_UoOL"> Signal</RegLink> or send a DM on <RegLink href="https://www.instagram.com/matineechocolate/">instagram</RegLink>.
        </p>
        <p>
          Alternatively, to place a shipped order, please enter your shipping information below.
        </p>
      </Hyphenated>
    </div>
    )
}

export default About